import { FC } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Box } from '../../../../layout/Box';
import { Flex } from '../../../../layout/Flex';
import { ProductSnippet } from '../../../../product/ProductSnippet/ProductSnippet';
import { PostTextCatalogLink } from '../PostTextCatalogLink/PostTextCatalogLink';
import { PostProductsProps } from './types';

export const PostProducts: FC<PostProductsProps> = ({
    products,
    onPostTextProductsClick,
    post,
    onPostTextCatalogClick,
}) => {
    const productCount = products.items.length;
    const t = useTranslation();

    if (!productCount) {
        return null;
    }

    return (
        <Box width="100%" mb={3} mt={2}>
            {productCount === 1 ? (
                <ProductSnippet
                    key={products.items[0].id}
                    product={products.items[0]}
                    onClick={() => onPostTextProductsClick(products.items[0])}
                    showSiteButton
                    post={post}
                    siteButtonText={t('Купить на сайте')}
                />
            ) : (
                <Flex direction={'column'} spacing={1}>
                    {products.items.map((product) => (
                        <ProductSnippet
                            key={product.id}
                            product={product}
                            post={post}
                            onClick={() => onPostTextProductsClick(product)}
                            isMultipleProducts
                        />
                    ))}
                </Flex>
            )}

            {post && onPostTextCatalogClick ? (
                <Box mt={1}>
                    <PostTextCatalogLink
                        post={post}
                        onPostTextCatalogClick={onPostTextCatalogClick}
                    />
                </Box>
            ) : null}
        </Box>
    );
};
